var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCredMouraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4808 17.0625L30.0194 32.5617L17.1505 45.398L1.60898 29.8928L14.4808 17.0625Z",
    fill: "#F8BC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5192 17.1043L29.9777 1.60205L14.4808 17.0627L30.0194 32.5619L42.8465 45.3595L58.391 29.8544L45.5192 17.1043Z",
    fill: "#015182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 29.8513L46.3207 16.2987L29.9777 0L13.7478 16.1888L0 29.8929L17.1505 47L30.0194 34.1637L42.8465 46.9584L60 29.8483V29.8513ZM17.1505 43.7932L3.21498 29.8929L14.4778 18.6645L28.4104 32.5618L17.1505 43.7932ZM16.0868 17.0625L29.9777 3.20684L44.7117 17.9036L56.7761 29.8572L42.8435 43.7545L31.6224 32.5618L16.0838 17.0625H16.0868Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 47,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredMouraIcon);
export default __webpack_public_path__ + "static/media/cred-moura-icon.f1de13563f5aa2668ea196a87be7942f.svg";
export { ForwardRef as ReactComponent };